import { Form } from '@deere/ux.uxframe-react'
import { getAnswerLabel, findAnswerIndex, containsCheckBoxAnswer, getTranslation } from '../utils/utils';
import { DebounceInput } from 'react-debounce-input';
import { useTranslation } from "react-i18next";

export default function DateOfpSection({ ofpSection, dateQuestion, updateCheckAnswer, updateAnswer, answers, checkedProprietary }) {
    const { t } = useTranslation();

    function updateDate(e, date) {
        updateAnswer(e.target.value, date.id);
    }

    function createDependentDate(checkValue) {
        let checked = false;
        let dependentQuestion;
        let indexQuestion = findAnswerIndex(dateQuestion.id, answers);
        //get Dependent Question
        if (indexQuestion >= 0 && containsCheckBoxAnswer(checkValue, answers[indexQuestion].answer)) {
            let indexDependentQuestion = ofpSection.questions.findIndex(q => parseInt(q.idQuestionDepends) === parseInt(dateQuestion.id)
                && q.idSelectionDependson.toString() === checkValue && q.type === 'DATE');
            if (indexDependentQuestion >= 0) {
                checked = true;
                dependentQuestion = ofpSection.questions[indexDependentQuestion];
            }
        }
        let answerLabel = dependentQuestion ? getAnswerLabel(dependentQuestion, answers) : '-';//For Dates
        //Special case 7 for Other
        if (checkValue === '7') {
            let indexText = ofpSection.questions.findIndex(q => q.idQuestionDepends === dateQuestion.id
                && q.idSelectionDependson.toString() === checkValue && q.type === 'OPEN_DATE');
            let indxTextAnswer = findAnswerIndex(ofpSection.questions[indexText].id, answers)//answers.findIndex(q => q.idQuestion === parseInt(ofpSection.questions[indexText].id))
            return checked ? <div><Form.Group className="pl-4  col-12">
                <Form.Label className="uxf-label">{getTranslation(dependentQuestion, 'text')}</Form.Label>
                <Form.Control type="date" required={!checkedProprietary} id={dependentQuestion.id}
                    data-testid={dependentQuestion.id}
                    defaultValue={answerLabel !== '-' ? answerLabel : ''}
                    onChange={e => updateDate(e, dependentQuestion)}
                    name={`${getTranslation(ofpSection, 'description')}-${dependentQuestion.id}`}
                />
                <div className="invalid-feedback">{t('bs_required')}</div>
            </Form.Group>
                <Form.Group className="pl-4  col-24">
                    <Form.Label className="uxf-label">{getTranslation(ofpSection.questions[indexText], 'text')}</Form.Label>
                    <DebounceInput required={!checkedProprietary} element="textarea" rows="2" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                        id={"ta" + ofpSection.questions[indexText].id}
                        onChange={(e) => updateAnswer(e, ofpSection.questions[indexText].id)}
                        data-testid='{ofpSection.questions[indexText].id}'
                        value={indxTextAnswer >= 0 ? answers[indxTextAnswer].answer : ''}
                        name={`${getTranslation(ofpSection, 'description')}-${ofpSection.questions[indexText].id}`} />
                    <div className="invalid-feedback">{t('bs_required')}</div>    
                </Form.Group>
            </div> : null;
        } else {//Other values
            return checked ? <Form.Group className="pl-4 col-12">
                <Form.Label className="uxf-label">{getTranslation(dependentQuestion, 'text')}</Form.Label>
                <Form.Control type="date" required={!checkedProprietary} id={dependentQuestion.id}
                    data-testid={dependentQuestion.id}
                    onChange={e => updateDate(e, dependentQuestion)}
                    defaultValue={answerLabel !== '-' ? answerLabel : ''}
                    name={`${getTranslation(ofpSection, 'description')}-${dependentQuestion.id}`} />
                <div className="invalid-feedback">{t('bs_required')}</div>    
            </Form.Group> : null;
        }
    }
    return (
        <>
            <Form.Row className="d-block mb-4">
                <Form.Group className="mb-4 pl-4">
                    <Form.Label className="uxf-label">{getTranslation(dateQuestion, 'text')}</Form.Label>
                </Form.Group>
            </Form.Row>
            <Form.Row className="d-block mb-4">
                <div>
                    {

                        dateQuestion.selections.sort((a, b) => (a.value > b.value) ? 1 : -1).map((sel, index) => {
                            let indx = findAnswerIndex(dateQuestion.id, answers);//answers.findIndex(e => parseInt(e.idQuestion) === parseInt(dateQuestion.id))
                            return <div key={sel.id}>
                                <Form.Group className="pl-4 col-12">
                                    <Form.Check name={`${getTranslation(ofpSection, 'description')}-${dateQuestion.id}`} id={sel.id} value={sel.value} key={sel.id} label={getTranslation(sel, 'text')} size='sm'
                                        onChange={(e) => updateCheckAnswer(e, dateQuestion.id)}
                                        data-testid={sel.id} defaultChecked={indx >= 0 && containsCheckBoxAnswer(sel.value, answers[indx].answer) ? true : false}
                                        checkedproprietary={checkedProprietary} />
                                </Form.Group>
                                {createDependentDate(sel.value)}
                            </div>
                        })
                    }
                </div>
            </Form.Row>
        </>
    )
}